import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import actionCreator from "../../../redux/action/actionCreator";

// core-components
import Toast from "../../../components/MessageToast";
import CreateForm from "../../components/forms/ProductForm";
import { CREATE_PRODUCT, UPDATE_PRODUCT } from "../../../redux/products/types";
import Loading from "../../../components/isLoading";
import { toast } from "react-toastify";
import BreadCrumps from "../../../components/BreadCrups";
import { fetchProductData } from "../../../redux/products";

export default (props) => {
	const { productId } = props;
	const dispatch = useDispatch();
	const operationStore = useSelector((store) =>
		productId ? store.updateProductGlobalStore : store.createProductGlobalStore
	);

	const productData = useSelector((state) => state.productGlobalStore);

	const [state, setState] = useState({
		openToast: false,
	});

	const openToast = ({ message, type, onClose }) =>
		Toast({ message, type, duration: 3000, onClose });

	useEffect(() => {
		if (productId && productId !== productData.data.id) {
			dispatch(fetchProductData(productId));
		}
	}, []);

	const handleFormSubmit = async (formData) => {
		const {
			title,
			summary,
			textContent,
			imageUrl,
			pdfUrl,
			benefits,
			requirements,
		} = formData;
		const productInfo = {
			title,
			summary,
			content: textContent,
			imageUrl,
			pdfUrl,
			benefits,
			requirements,
		};

		await toast.promise(
			dispatch(
				actionCreator({
					method: productId ? "PATCH" : "POST",
					path: productId ? `/api/products/${productId}` : `/api/products`,
					actionType: productId ? UPDATE_PRODUCT : CREATE_PRODUCT,
					data: productInfo,
				})
			),
			{
				pending: `${!productId ? "Creating" : "Updating"} Product`,
			}
		);

		setState({ ...state, openToast: true });
	};
	const navigate = useNavigate();

	if (operationStore.message && state.openToast) {
		Toast({
			message: operationStore.message,
			type: operationStore.message.includes("successful") ? "success" : "error",
			onClose: () =>
				operationStore.message.includes("successful") ? navigate(-1) : null,
		});

		setState({ ...state, openToast: false });
	}
	const crumps = [
		{
			title: "Products",
			path: "/products",
		},
		{
			title: "New",
		},
	];

	return (
		<div>
			<BreadCrumps crumps={crumps} />
			{productId && productData.loading ? (
				<Loading />
			) : (
				<div>
					<CreateForm
						isCreate={productId ? false : true}
						title={`${!productId ? "Create" : "Update"} Product`}
						onSubmit={handleFormSubmit}
						openToast={openToast}
						baseProductData={productId ? productData.data : {}}
						isLoading={operationStore.loading}
					/>
				</div>
			)}
		</div>
	);
};
